/* eslint-disable arrow-body-style */

import http from '@gp/utils/httpTS';

import type { IBaseResponse } from '@home/types/common';
import type { IRecord } from '@gp/types/global';
import type {
  IPipelineChangeDetailFilterConditionsDTO,
  IPipelineChangeDetailDTO,
  IPipelineChangeDetailFetchParams,
  IPipelineChangeDetailDownloadParams,
  IPipelineChangeChecklistFilterConditionsDTO,
  IPipelineChangeChecklistFetchParams,
  IPipelineChangeChecklistDownloadParams,
  IPipelineChangeChecklistRecordDTO,
} from '@gp/types/changeLog';

/**
 * 获取变更详情过滤条件
 * @param params - 可选参数对象
 * @returns 返回包含过滤条件的HTTP响应
 */
export const fetchChangeDetailFilterConditions = async (
  params: IRecord<any> = {},
): IBaseResponse<IPipelineChangeDetailFilterConditionsDTO> => {
  return http({
    url: '/api/v1/globalpedia_pc/project/change_detail_select',
    method: 'GET',
    params,
    rawData: true,
  }) as any;
};

/**
 * 获取变更详情列表
 * @param params - 请求参数对象
 * @returns 返回包含变更详情列表的HTTP响应
 */
export const fetchChangeDetails = async (
  params: IPipelineChangeDetailFetchParams,
): IBaseResponse<{ list: IPipelineChangeDetailDTO[] | null }> => {
  return http({
    url: '/api/v1/globalpedia_pc/project/change_detail_list',
    method: 'POST',
    data: params,
    rawData: true,
  }) as any;
};

/**
 * 下载变更详情列表
 * @param params - 下载参数对象
 * @returns 返回一个Promise对象，用于处理文件下载
 */
export const downloadChangeDetails = (params: IPipelineChangeDetailDownloadParams): Promise<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/project/change_detail_list_download',
    method: 'POST',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

/**
 * 获取Pipeline/Change Log/Change Checklist页面 筛选条件数据
 * @param params 参数对象
 */
export const fetchChangeChecklistFilterConditions = async (
  params: IRecord = {},
): IBaseResponse<IPipelineChangeChecklistFilterConditionsDTO> => {
  return http({
    url: '/api/v1/globalpedia_pc/project/change_checklist_select',
    method: 'GET',
    params,
    rawData: true,
  }) as any;
};

/**
 * 获取Pipeline/Change Log/Change Checklist页面 列表数据
 * @param params 参数对象
 */
export const fetchChangeChecklists = async (
  params: IPipelineChangeChecklistFetchParams,
): IBaseResponse<{ total: number | null; list: IPipelineChangeChecklistRecordDTO[] | null }> => {
  return http({
    url: '/api/v1/globalpedia_pc/project/change_checklist',
    method: 'POST',
    data: params,
    rawData: true,
  }) as any;
};

/**
 * 下载Pipeline/Change Log/Change Checklist页面 列表数据
 * @param params 参数对象
 */
export const downloadChangeChecklists = (params: IPipelineChangeChecklistDownloadParams): Promise<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/project/change_checklist_download',
    method: 'POST',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};
